import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import BankService from '../../core/BankService'

export const postLiquidity = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/liquidity',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BankService.postLiquidity(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadLiquidity = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/liquidity/export',
  async (params) => {
    const res = await BankService.downloadLiquidity(params)
    handleExport(res.data, res.filename)
  },
)
